import ChangeProgramCampusModalityRepository from '../../domain/repositories/ChangeProgramCampusModalityRepository';
import ChangeProgramCampusModalityDataStore from '../datastores/ChangeProgramCampusModalityDataStore';
import ChangeProgramCampusModalityDataStoreFactory from '../factories/ChangeProgramCampusModalityDataStoreFactory';

export default class ChangeProgramCampusModalityDataRepository
  implements ChangeProgramCampusModalityRepository
{
  registerChangeAcademicData(
    procedureId: number,
    modality: any,
    campus: any,
    program: any,
    files: any
  ) {
    const changeProgramCampusModalityDataStore: ChangeProgramCampusModalityDataStore =
      ChangeProgramCampusModalityDataStoreFactory.create();
    return changeProgramCampusModalityDataStore.registerChangeAcademicData(
      procedureId,
      modality,
      campus,
      program,
      files
    );
  }

  activateChangeAcademicData(
    requestId: number,
    procedureId: number,
    campus: string,
    career: string
  ) {
    const changeProgramCampusModalityDataStore: ChangeProgramCampusModalityDataStore =
      ChangeProgramCampusModalityDataStoreFactory.create();
    return changeProgramCampusModalityDataStore.activateChangeAcademicData(
      requestId,
      procedureId,
      campus,
      career
    );
  }

  cancel(requestId: number, procedureId: number) {
    const changeProgramCampusModalityDataStore: ChangeProgramCampusModalityDataStore =
      ChangeProgramCampusModalityDataStoreFactory.create();
    return changeProgramCampusModalityDataStore.cancel(requestId, procedureId);
  }
}
